function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var GameTemplate = require('./../../lib/templates/gametemplate');
var QuakeGameOptionsTemplate = require('./lib/quake-game-options.template');
var QuakeControls = require('./lib/controls');
var Quake3 = /*#__PURE__*/function (_GameTemplate) {
  function Quake3(app) {
    var _this;
    _classCallCheck(this, Quake3);
    _this = _callSuper(this, Quake3, [app]);
    _this.app = app;
    _this.name = 'Quake3';
    _this.slug = 'quake3';
    _this.description = 'Quake3 is a multiplayer first-person-shooter originally released by ID Software in 1999. This version runs directly in your browser and connects with Saito to use other Saito applications and bring modules right into the game.';
    _this.categories = 'Games Videogame Shooter';
    _this.publisher_message = 'Quake 3 is owned by ID Software. This module is made available under an open source license. Your browser will use data-files distributed freely online by the publisher but please note that the publisher requires purchase of the game to play. Saito recommends GOG.com for purchase.';
    _this.status = 'beta';
    _this["class"] = 'app';
    _this.controls = {};
    _this.controls = new QuakeControls(app, _this);
    _this.minPlayers = 1;
    _this.maxPlayers = 4;
    _this.scripts = ['/quake3/ioquake3.js'];

    //
    // something specific for this implementation
    //
    _this.crypto_msg = 'tribute per kill';

    // ask chat not to start on launch
    _this.request_no_interrupts = true;

    //
    // US SERVER
    //
    //this.content_server = 'q3-us.saito.io';
    //this.game_server = 'q3-us.saito.io:27959';

    //
    // ASIA SERVER
    //
    //this.content_server = 'q3.saito.io';
    //this.game_server = 'q3.saito.io:27960';

    //this.content_server  = "quake.adsotrans.com";
    //this.game_server     = "quake.adsotrans.com:27960";

    _this.content_server = 'quake.adsotrans.com';
    _this.game_server = 'quake.adsotrans.com';

    //this.content_server  = "quake.adsotrans.com:80";
    //this.game_server     = "18.162.50.137:27960";
    return _this;
  }
  _inherits(Quake3, _GameTemplate);
  return _createClass(Quake3, [{
    key: "handleGameLoop",
    value: function handleGameLoop() {
      ///////////
      // QUEUE //
      ///////////
      if (this.game.queue.length > 0) {
        var qe = this.game.queue.length - 1;
        var mv = this.game.queue[qe].split('\t');
        var shd_continue = 1;
        console.log('QUEUE: ' + JSON.stringify(this.game.queue));
        if (mv[0] === 'init') {
          return 0;
        }
        if (mv[0] === 'player_kill') {
          this.game.queue.splice(qe, 1);
          var victim = mv[1];
          var killer = mv[2];
          var victim_web3_address = '';
          var killer_web3_address = '';
          for (var i = 0; i < this.game.players.length; i++) {
            if (this.game.players[i] === victim) {
              victim_web3_address = this.game.keys[i];
            }
            if (this.game.players[i] === killer) {
              killer_web3_address = this.game.keys[i];
            }
          }

          //
          // victim offers sacrificial tribue
          //
          if (this.game.options.crypto) {
            if (this.publicKey === victim) {
              var ts = new Date().getTime();
              var ticker = this.game.options.crypto;
              var stake = this.game.options.stake;
              var uhash = this.app.crypto.hash("".concat(victim).concat(killer).concat(this.game.step.game));
              // the user is proactively sending tokens unsolicited, so we can skip the
              // confirmation prompt provided by the crypto-manager.
              this.app.wallet.sendPayment([victim_web3_address], [killer_web3_address], [stake], ts, uhash, function () {
                siteMessage("".concat(stake, " ").concat(ticker, " sent in tribute"), 8000);
              }, ticker);
            } else {
              var _ts = new Date().getTime();
              var _ticker = this.game.options.crypto;
              var _stake = this.game.options.stake;
              var _uhash = this.app.crypto.hash("".concat(victim).concat(killer).concat(this.game.step.game));
              //
              // monitor for receipt
              //
              //this.app.wallet.receivePayment(ticker, victim_web3_address, stake, uhash);

              // You don't need to monitor for receipt, if you receive crypto, you will get a siteMessage anyways
            }
          }
          return 1;
        }
        if (mv[0] === 'player_name') {
          this.game.queue.splice(qe, 1);
          var publickey = mv[1];
          var name = mv[2];
          this.setPlayerName(publickey, name);
          if (publickey === this.publicKey) {
            this.game.player_name_identified = true;
          }
          return 1;
        }

        //
        // avoid infinite loops
        //
        if (shd_continue == 0) {
          console.log('NOT CONTINUING');
          return 0;
        }
      } else {
        console.log('QUEUE EMPTY!');
      }
      return 1;
    }
  }, {
    key: "returnGameOptionsHTML",
    value: function returnGameOptionsHTML() {
      return QuakeGameOptionsTemplate(this.app, this);
    }
  }, {
    key: "attachAdvancedOptionsEventListeners",
    value: function attachAdvancedOptionsEventListeners() {
      var crypto = document.getElementById('crypto');
      var stake = document.getElementById('stake');
      var stake_wrapper = document.getElementById('stake_wrapper');
      var updateChips = function updateChips() {
        if (stake) {
          if (crypto.value == '') {
            stake_wrapper.style.display = 'none';
            stake.value = '0';
          } else {
            var stakeAmt = parseFloat(stake.value);
            stake_wrapper.style.display = 'block';
          }
        }
      };
      if (crypto) {
        crypto.onchange = updateChips;
      }
      if (stake) {
        stake.onchange = updateChips;
      }
    }
  }, {
    key: "initializeGame",
    value: function initializeGame(game_id) {
      this.load();
      if (!this.game.state) {
        var _this$game;
        console.log('******Generating the Game******');
        this.game.state = {};
        this.game.queue = [];
        this.game.queue.push('init');
        this.game.queue.push('READY');

        //
        // when we join a game, we remember the name
        //
        this.game.player_name = '';
        this.game.all_player_names = [];

        //
        // set player names
        //
        if ((_this$game = this.game) !== null && _this$game !== void 0 && _this$game.players) {
          for (var i = 0; i < this.game.players.length; i++) {
            this.game.all_player_names[i] = '';
          }
        }
      }

      //
      // if older game, force re-registration on reload
      //
      this.game.player_name_identified = false;
    }
  }, {
    key: "initialize",
    value: function initialize(app) {
      var _this2 = this;
      if (app.BROWSER == 0) {
        return;
      }
      _superPropGet(Quake3, "initialize", this, 3)([app]);
      if (this.browser_active) {
        //
        // bind console.log to track outside app
        //
        var log = console.log.bind(console);
        console.log = function () {
          if (arguments.length > 0) {
            if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
              _this2.processQuakeLog(arguments.length <= 0 ? undefined : arguments[0], log);
            }
            log.apply(void 0, arguments);
          }
        };
      }
    }

    //
    // for the love of God don't add console.logs within this function
    //
  }, {
    key: "processQuakeLog",
    value: function processQuakeLog() {
      var _this$game2;
      var logline = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var log = arguments.length > 1 ? arguments[1] : undefined;
      //
      // register publickey/name when we enter the game if unset
      //
      if (this.game.player_name_identified == false) {
        if (logline.indexOf('entered the game') > 0) {
          var q3self = this;
          setTimeout(function () {
            q3self.registerPlayerName();
          }, 500);

          // load & apply saved controls while here
          // since this block only happens on client startup
          try {
            setTimeout(function () {
              q3self.controls.loadSavedControls();
              q3self.controls.writeControls();
              q3self.controls.applyControls();
            }, 1500);
          } catch (err) {
            console.log('ERROR LOADING CONTROLS: ' + err);
          }
        }
      }

      //
      // someone got murdered
      //
      if ((_this$game2 = this.game) !== null && _this$game2 !== void 0 && _this$game2.all_player_names) {
        for (var z = 0; z < this.game.all_player_names.length; z++) {
          var pn = this.game.all_player_names[z].toLowerCase().substring(0, 15);

          //log("1::: " + logline);

          var pos = logline.indexOf(pn);
          if (pos == 0) {
            //log("2::: " + logline);
            for (var i = 0; i < this.game.all_player_names.length; i++) {
              var pn2 = this.game.all_player_names[i].toLowerCase().substring(0, 15);
              //log("searching for pn2: " + pn2);
              if (pn !== pn2) {
                //log("not the same as pn");
                if (logline.indexOf(pn2) > -1) {
                  //log("3::: " + logline);
                  var victim = z;
                  var killer = i;
                  //log(this.game.players[victim] + " --- " + this.publicKey);
                  if (this.game.players[victim] === this.publicKey) {
                    console.log('THIS ONE IS ON US');
                    this.addMove('player_kill\t' + this.game.players[victim] + '\t' + this.game.players[killer]);
                    this.addMove("ROUNDOVER\t".concat(JSON.stringify([this.game.players[killer]]), "\t").concat(JSON.stringify([this.game.players[victim]])));
                    this.endTurn();
                  }
                }
              }
            }
          }
        }
      }
    }
  }, {
    key: "registerPlayerName",
    value: function registerPlayerName() {
      //
      // prevent Saito components from processing
      //
      SAITO_COMPONENT_ACTIVE = false;
      SAITO_COMPONENT_CLICKED = false;
      if (document.getElementById('chat-container')) {
        document.getElementById('chat-container').remove();
      }
      if (document.getElementById('viewport')) {
        document.getElementById('viewport').focus();
      }
      document.dispatchEvent(new KeyboardEvent('keydown', {
        keyCode: 192
      }));

      // type "/name "
      document.dispatchEvent(new KeyboardEvent('keydown', {
        keyCode: 191
      }));
      document.dispatchEvent(new KeyboardEvent('keydown', {
        keyCode: 78
      }));
      document.dispatchEvent(new KeyboardEvent('keydown', {
        keyCode: 65
      }));
      document.dispatchEvent(new KeyboardEvent('keydown', {
        keyCode: 77
      }));
      document.dispatchEvent(new KeyboardEvent('keydown', {
        keyCode: 69
      }));
      document.dispatchEvent(new KeyboardEvent('keydown', {
        keyCode: 32
      }));

      // type lowercase publickey
      var publickey = this.publicKey.toLowerCase();
      for (var z = 0; z < publickey.length; z++) {
        var _char = publickey[z];
        var charCode = _char.charCodeAt(0);
        if (charCode > 65) {
          charCode -= 32;
        } // 97 -> 65
        console.log('typing in: ' + _char);
        document.dispatchEvent(new KeyboardEvent('keydown', {
          keyCode: charCode
        }));
      }

      // type "enter" and hide console (w/ tilde)
      document.dispatchEvent(new KeyboardEvent('keydown', {
        keyCode: 13
      }));
      document.dispatchEvent(new KeyboardEvent('keydown', {
        keyCode: 192
      }));
      this.setPlayerName(this.publicKey, publickey);
      this.addMove('player_name\t' + this.publicKey + '\t' + this.game.player_name);
      this.endTurn();
      return;
    }
  }, {
    key: "setPlayerName",
    value: function setPlayerName(publickey, name) {
      for (var i = 0; i < this.game.players.length; i++) {
        if (this.game.players[i] === publickey) {
          this.game.all_player_names[i] = name;
          console.log('PLAYER ' + (i + 1) + ' is ' + name);
        }
      }
      if (this.publicKey === publickey) {
        this.game.player_name = name;
      }
    }
  }, {
    key: "onPeerHandshakeComplete",
    value: function onPeerHandshakeComplete(app, peer) {
      if (app.BROWSER == 0 || !document) {
        return;
      }
      if (this.browser_active == 1) {
        if (document.querySelector('.chat-input')) {
          var c = document.querySelector('.chat-input');
          if (c) {
            c.placeholder = 'typing T activates chat...';
          }
        }
      }
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app) {
        var getQueryCommands, resizeViewport, args, _startGame;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(this.browser_active != 1)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              if (!this.initialize_game_run) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              _context3.n = 3;
              return this.injectGameHTML("<div id=\"viewport-frame\"></div>");
            case 3:
              _context3.n = 4;
              return _superPropGet(Quake3, "render", this, 3)([app]);
            case 4:
              //
              // ADD MENU
              //
              this.menu.addMenuOption('game-game', 'Game');
              this.menu.addMenuOption('game-controls-menu', 'Controls');
              this.menu.addSubMenuOption('game-controls-menu', {
                text: 'Settings',
                id: 'game-controls',
                "class": 'game-game-controls',
                callback: function () {
                  var _callback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, game_mod) {
                    return _regenerator().w(function (_context) {
                      while (1) switch (_context.n) {
                        case 0:
                          game_mod.menu.hideSubMenus();
                          //if (!game_mod.controls) {game_mod.controls = new QuakeControls(app, game_mod);}
                          //game_mod.controls = new QuakeControls(app, game_mod);
                          game_mod.controls.overlay.hide();
                          _context.n = 1;
                          return game_mod.controls.render(app, game_mod);
                        case 1:
                          SAITO_COMPONENT_ACTIVE = true;
                          SAITO_COMPONENT_CLICKED = true;
                        case 2:
                          return _context.a(2);
                      }
                    }, _callee);
                  }));
                  function callback(_x2, _x3) {
                    return _callback.apply(this, arguments);
                  }
                  return callback;
                }()
              });
              this.menu.addSubMenuOption('game-game', {
                text: 'Update Name',
                id: 'game-register',
                "class": 'game-register',
                callback: function () {
                  var _callback2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app, game_mod) {
                    return _regenerator().w(function (_context2) {
                      while (1) switch (_context2.n) {
                        case 0:
                          siteMessage('Updating Player Name to Saito Address');
                          game_mod.menu.hideSubMenus();
                          game_mod.registerPlayerName();
                        case 1:
                          return _context2.a(2);
                      }
                    }, _callee2);
                  }));
                  function callback(_x4, _x5) {
                    return _callback2.apply(this, arguments);
                  }
                  return callback;
                }()
              });
              this.menu.addChatMenu();
              this.menu.render();
              if (app.BROWSER) {
                if (this.game.options.server === 'as') {
                  this.content_server = 'q3.saito.io';
                  this.game_server = 'q3.saito.io:27960';
                }
                if (this.game.options.server === 'na') {
                  this.content_server = 'q3-us.saito.io';
                  this.game_server = 'q3-us.saito.io:27959';
                }
              }

              //
              // helper functions
              //
              getQueryCommands = function getQueryCommands() {
                var search = /([^&=]+)/g;
                var query = window.location.search.substring(1);
                var args = [];
                var match;
                while (match = search.exec(query)) {
                  var val = decodeURIComponent(match[1]);
                  val = val.split(' ');
                  val[0] = '+' + val[0];
                  args.push.apply(args, val);
                }
                return args;
              };
              resizeViewport = function resizeViewport() {
                if (!ioq3.canvas) {
                  return;
                }
                if (document['webkitFullScreenElement'] || document['webkitFullscreenElement'] || document['mozFullScreenElement'] || document['mozFullscreenElement'] || document['fullScreenElement'] || document['fullscreenElement']) {
                  return;
                }
                ioq3.setCanvasSize(ioq3.viewport.offsetWidth, ioq3.viewport.offsetHeight);
              };
              console.log('**************\nQUAKE LOADED\n***********');

              // merge default args with query string args
              //var args = ['+set', 'fs_cdn', 'content.quakejs.com:80', '+set', 'sv_master1', 'master.quakejs.com:27950']; //original args to list the servers from master.quakejs.com
              //var args = ['+set', 'fs_cdn', 'content.quakejs.com:80', '+set', 'sv_master1', 'master.quakejs.com:27950', '+connect', 'YOUR_SERVER_HERE:27960']; //additional +connect arguement to connect to a specific server
              //var args = ['+set', 'fs_cdn', '18.163.184.251:80', '+connect', '18.163.184.251:27960']; //custom args list targeting a local content server and local game server both at the address 'quakejs'
              args = ['+set', 'fs_cdn', this.content_server, '+connect', this.game_server];
              args.push.apply(args, getQueryCommands());
              if (this.browser_active == 1) {
                _startGame = function startGame() {
                  if (typeof ioq3 !== 'undefined') {
                    console.log('ioq3', ioq3);
                    window.addEventListener('resize', resizeViewport);
                    ioq3.viewport = document.getElementById('viewport-frame');
                    ioq3.elementPointerLock = true;
                    ioq3.exitHandler = function (err) {
                      console.log(err);
                      return;
                      if (err) {
                        var form = document.createElement('form');
                        form.setAttribute('method', 'POST');
                        form.setAttribute('action', '/');
                        var hiddenField = document.createElement('input');
                        hiddenField.setAttribute('type', 'hidden');
                        hiddenField.setAttribute('name', 'error');
                        hiddenField.setAttribute('value', err);
                        form.appendChild(hiddenField);
                        document.body.appendChild(form);
                        form.submit();
                        return;
                      }
                      window.location.href = '/';
                    };
                    console.log('QUAKE ARGS:', args);
                    ioq3.callMain(args);
                  } else {
                    console.log('Wait a minute...');
                    setTimeout(_startGame, 1000);
                  }
                };
                _startGame();
              }
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function render(_x) {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "load",
    value: function load() {
      this.quake3 = this.app.options.quake3;
    }
  }, {
    key: "save",
    value: function save() {
      this.app.options.quake3 = this.quake3;
      this.app.storage.saveOptions();
    }
  }]);
}(GameTemplate);
module.exports = Quake3;